import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { MODAL } from '../../context';
import { useApp, usePageOwner, useShareUrls } from '../../hooks';
import Modal from '../Modal/Modal';
import { ShareModal } from '../ShareModal/ShareModal';
import { EncourageShareModal } from './EncourageShareModal';

export const EncourageShareModalContainer: FunctionComponent = () => {
  const { hideModal, showModal, openModal } = useApp();
  const storageKey = 'isEncourageSharePromptDismissed';
  const closeModal = () => {
    localStorage.setItem(storageKey, String(true));
    hideModal();
  };

  useEffect(() => {
    const userHasDismissed = localStorage.getItem(storageKey) === String(true);

    if (userHasDismissed) {
      return;
    }

    const timer = global.setTimeout(() => {
      showModal({ modal: MODAL.ENCOURAGE_SHARE });
    }, 40000);

    return () => clearTimeout(timer);
  }, [showModal]);

  const { t } = useTranslation('common', { useSuspense: false });
  const shareUrls = useShareUrls();
  const { data } = usePageOwner();

  return (
    <>
      {openModal === MODAL.ENCOURAGE_SHARE && (
        <Modal onCloseRequest={closeModal}>
          <EncourageShareModal onClose={closeModal} />
        </Modal>
      )}
      {openModal === MODAL.SHARE && shareUrls && (
        <ShareModal
          heading={t('shareModal.heading', {
            pageOwner: data?.owner?.name,
          })}
          description={t('shareModal.description')}
          onClose={closeModal}
          shareItems={shareUrls}
        />
      )}
    </>
  );
};
